import { apiRequest } from './client'

// RFC-0856 I10: the browser flag snapshot from GET /config/flags. Value-only
// (no version/source/rules/PII); v0 scalar value types. Kept resilient — the
// hook layer treats values defensively (apiRequest does an unchecked JSON.parse).
export interface ClientFlagsResponse {
  flags: Record<string, boolean | number | string>
}

export function fetchClientFlags(): Promise<ClientFlagsResponse> {
  return apiRequest<ClientFlagsResponse>('/config/flags')
}
